export default __webpack_public_path__ + "static/media/osaamiskartoitus-koonti.4a1d9535.png";